import { Button } from '@/components/ui/button';

export function CleicWaitlist() {
  return (
    <section id="cleic" data-guide-label="Cleic" className="border-b border-ink/5 bg-paper">
      <div className="mx-auto max-w-3xl px-6 py-24 text-center">
        <h2 className="font-display text-3xl tracking-tight md:text-4xl">
          Cleic Founding Charter is opening carefully.
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-ink/70">
          Cleic is the finance operating layer I am building from real close,
          reporting, and systems work. The first cohort is capped, staged, and
          application-gated so early operators get founder proximity without
          sending private records through a public page.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Button asChild>
            <a href="https://cleic.com/founding-charter">
              Apply for Founding Charter
            </a>
          </Button>
          <Button asChild variant="outline">
            <a href="mailto:jl@jlpatawaran.com?subject=Cleic%20conversation">
              Ask about Cleic
            </a>
          </Button>
        </div>
        <p className="mx-auto mt-4 max-w-xl text-xs leading-relaxed text-ink/50">
          Application does not reserve a seat, collect payment, grant access, or
          create equity, governance, roadmap, endorsement, or fixed-price rights.
        </p>
      </div>
    </section>
  );
}
